import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import PhdesignEditForm from './PhdesignEditForm';
import PhdesignList from './PhdesignList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import PhdesignListView from './PhdesignListView'


export default function PhdesignDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.phdesignDashboard);
  const [ phdesignId, setPhdesignId] = React.useState('');
  const [reloadPhdesignList, setReloadPhdesignList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <PhdesignEditForm 
            setReloadPhdesignList={setReloadPhdesignList}
            phdesignId={phdesignId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <PhdesignListView 
                      setPhdesignId = {setPhdesignId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
